import { Tabs, Tab, DrawerBody, DrawerTitle } from "@growtherapy/sprout-ui";
import { useTranslate } from "@growtherapy/i18n";
import { useState } from "react";
import { DrawerHeader } from "../DrawerHeader";
import {
  faImageUser,
  faMicrophone,
  faUniversalAccess,
  faVideo,
} from "@fortawesome/pro-solid-svg-icons";

export enum SettingsDrawerTab {
  VIDEO = "video",
  AUDIO = "audio",
  BACKGROUND = "background",
  ACCESSIBILITY = "accessibility",
}

export type TabMap = Record<SettingsDrawerTab, JSX.Element | undefined>;

export function SettingsDrawer({ tabMap }: { tabMap: TabMap }) {
  const t = useTranslate();
  const [selectedTab, setSelectedTab] = useState<SettingsDrawerTab>(
    SettingsDrawerTab.VIDEO,
  );

  return (
    <>
      <DrawerHeader>
        <DrawerTitle>{t("telehealth-core:settings.settings")}</DrawerTitle>
      </DrawerHeader>
      <DrawerBody>
        <Tabs
          selectedTabId={selectedTab}
          onSelectTab={(newTab: SettingsDrawerTab) => {
            setSelectedTab(newTab);
          }}
          className="w-full overflow-x-scroll no-scrollbar flex gap-2"
        >
          {/**
           * Fragmnets used below because the Tabs component is very strict
           * about its child types - null, undefined, etc. are not allowed
           */}
          {SettingsDrawerTab.VIDEO in tabMap ? (
            <Tab
              tabId="video"
              className="whitespace-nowrap"
              icon={faVideo}
              title={t("telehealth-core:settings.video")}
            />
          ) : (
            <></>
          )}
          {SettingsDrawerTab.AUDIO in tabMap ? (
            <Tab
              tabId="audio"
              className="whitespace-nowrap"
              icon={faMicrophone}
              title={t("telehealth-core:settings.audio")}
            />
          ) : (
            <></>
          )}
          {SettingsDrawerTab.BACKGROUND in tabMap ? (
            <Tab
              tabId="background"
              className="whitespace-nowrap"
              icon={faImageUser}
              title={t("telehealth-core:settings.background")}
            />
          ) : (
            <></>
          )}
          {SettingsDrawerTab.ACCESSIBILITY in tabMap ? (
            <Tab
              tabId="accessibility"
              className="whitespace-nowrap"
              icon={faUniversalAccess}
              title={t("telehealth-core:settings.accessibility")}
            />
          ) : (
            <></>
          )}
        </Tabs>
        {tabMap[selectedTab]}
      </DrawerBody>
    </>
  );
}
